class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class HeaderMenuHover extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.link = this.querySelector('[data-header-menu-link]');
    this.panel = this.querySelector('[data-header-menu-panel]');
    this.closeDelayMs = 180;
    this.closeTimeout = null;

    if (!this.link || !this.panel) return;

    this.open = this.open.bind(this);
    this.scheduleClose = this.scheduleClose.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);

    this.addEventListener('mouseenter', this.open);
    this.addEventListener('mouseleave', this.scheduleClose);
    this.addEventListener('focusin', this.open);
    this.addEventListener('focusout', this.onFocusOut);
    document.addEventListener('keyup', this.onKeyUp);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('keyup', this.onKeyUp);
    document.removeEventListener('click', this.onDocumentClick);
  }

  get isOpen() {
    return this.hasAttribute('open');
  }

  open() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    if (this.isOpen) return;

    document.querySelectorAll('header-menu-hover[open]').forEach((menu) => {
      if (menu !== this) menu.close();
    });

    this.setAttribute('open', '');
    this.panel.hidden = false;
    this.link.setAttribute('aria-expanded', 'true');
    this.updateHeaderState(true);
    this.playOpenAnimations();
  }

  scheduleClose() {
    if (this.closeTimeout) clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => this.close(), this.closeDelayMs);
  }

  close() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    if (!this.isOpen) return;

    this.removeAttribute('open');
    this.panel.hidden = true;
    this.link.setAttribute('aria-expanded', 'false');
    this.updateHeaderState(false);
    this.cancelOpenAnimations();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyUp(event) {
    if (event.code === 'Escape' && this.isOpen) {
      this.close();
      this.link.focus();
    }
  }

  onDocumentClick(event) {
    if (this.isOpen && !this.contains(event.target)) this.close();
  }

  updateHeaderState(isOpen) {
    if (!this.header) return;
    this.header.preventHide = isOpen;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  playOpenAnimations() {
    requestAnimationFrame(() => {
      this.panel.getAnimations().forEach((animation) => animation.play());
    });
  }

  cancelOpenAnimations() {
    this.panel.getAnimations().forEach((animation) => animation.cancel());
  }
}

customElements.define('header-menu-hover', HeaderMenuHover);
